
export const trainingCategories = {
  "Basic Classes": [
    "Basic Training",
    "Beginners Class",
    "Fitness Training"
  ],
  "Group Training": [
    "Monday Group Training",
    "Tuesday Group Training", 
    "Wednesday Group Training",
    "Thursday Group Training",
    "Friday Group Training",
    "Saturday Group Training",
    "Sunday Group Training"
  ],
  "Technical Training": [
    "Kata Practice",
    "Technique Workshop", 
    "Advanced Training"
  ],
  "Combat Training": [
    "Sparring Training",
    "Competition Preparation",
    "Self Defense"
  ],
  "Special Sessions": [
    "Belt Promotion Session",
    "Custom"
  ]
};
